(() => {
  if (window.sbCartDrawer) return;
  window.sbCartDrawer = true;

  const TIMER_KEY = 'sbCartTimerEnd';
  let memoryEnd = 0;
  const readEnd = () => {
    try {
      return Number(sessionStorage.getItem(TIMER_KEY)) || memoryEnd;
    } catch (e) {
      return memoryEnd;
    }
  };
  const writeEnd = (value) => {
    memoryEnd = value;
    try {
      sessionStorage.setItem(TIMER_KEY, String(value));
    } catch (e) {}
  };

  if (!customElements.get('sb-cart-timer')) {
    customElements.define(
      'sb-cart-timer',
      class extends HTMLElement {
        connectedCallback() {
          const span = (Number(this.dataset.minutes) || 5) * 60000;
          const tick = () => {
            let end = readEnd();
            if (end <= Date.now() || end - Date.now() > span) {
              end = Date.now() + span;
              writeEnd(end);
            }
            const left = Math.ceil((end - Date.now()) / 1000);
            this.textContent = `${String(Math.floor(left / 60)).padStart(2, '0')}:${String(left % 60).padStart(2, '0')}`;
          };
          tick();
          this.interval = setInterval(tick, 1000);
        }

        disconnectedCallback() {
          clearInterval(this.interval);
        }
      }
    );
  }

  const recoCache = new Map();
  if (!customElements.get('sb-cart-reco')) {
    customElements.define(
      'sb-cart-reco',
      class extends HTMLElement {
        async connectedCallback() {
          const url = this.dataset.url;
          if (!recoCache.has(url)) {
            recoCache.set(
              url,
              fetch(url)
                .then((response) => (response.ok ? response.text() : ''))
                .then((text) => new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section')?.innerHTML || '')
                .catch(() => '')
            );
          }
          const html = await recoCache.get(url);
          if (this.isConnected) this.innerHTML = html;
        }
      }
    );
  }

  const pickVariant = (card) => {
    const data = card.querySelector('[data-sbcd-variants]');
    if (!data) return null;
    const picked = [...card.querySelectorAll('[data-sbcd-option]')].map((el) => ({
      index: Number(el.dataset.sbcdOption),
      value: el.tagName === 'SELECT' ? el.value : el.querySelector('.is-selected')?.dataset.value,
    }));
    return JSON.parse(data.textContent).find((v) => picked.every((p) => v.o[p.index] === p.value)) || false;
  };

  const syncCard = (card) => {
    const variant = pickVariant(card);
    if (variant === null) return;
    const button = card.querySelector('[data-sbcd-add]');
    const available = Boolean(variant && variant.a);
    if (variant) button.dataset.variantId = variant.id;
    button.disabled = !available;
    button.textContent = available ? 'ADD' : 'SOLD OUT';
  };

  const showError = (message) => {
    const box = document.getElementById('CartDrawer-CartErrors');
    if (box) box.textContent = message;
  };

  const addToCart = async (button) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    button.disabled = true;
    showError('');
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: drawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok) throw new Error(state.description || state.message);
      drawer.renderContents(state);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sb-cart-upsell', productVariantId: button.dataset.variantId, cartData: state });
      }
    } catch (error) {
      button.disabled = false;
      showError(error.message || window.cartStrings?.error || '');
    }
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.sbcd .sbcd-up__swatch');
    if (swatch) {
      swatch.parentElement.querySelectorAll('.sbcd-up__swatch').forEach((item) => {
        item.classList.toggle('is-selected', item === swatch);
        item.setAttribute('aria-checked', String(item === swatch));
      });
      syncCard(swatch.closest('[data-sbcd-card]'));
      return;
    }

    const arrow = event.target.closest('.sbcd [data-sbcd-page]');
    if (arrow) {
      const root = arrow.closest('[data-sbcd-up]');
      const pages = [...root.querySelectorAll('[data-sbcd-pg]')];
      const current = pages.findIndex((page) => !page.hidden);
      const next = (current + Number(arrow.dataset.sbcdPage) + pages.length) % pages.length;
      pages.forEach((page, index) => {
        page.hidden = index !== next;
      });
      root.querySelector('[data-sbcd-counter]').textContent = `${next + 1}/${pages.length}`;
      return;
    }

    const add = event.target.closest('.sbcd [data-sbcd-add]');
    if (add && !add.disabled) addToCart(add);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('.sbcd .sbcd-up__select')) syncCard(event.target.closest('[data-sbcd-card]'));
  });
})();
